import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';
import { encryptData } from '../../utils/hashing';

const customerSummaryClient = async (customerNumber) => {
    const { post: postClient } = BaseClient();
    try {
        customerNumber = process.env.REACT_APP_CUSLOC_ENABLE === "true" ? `${customerNumber}__customervalue${Date.now()}` : customerNumber;
        let requestBody = {
            "CustomerNumber": encryptData(customerNumber, "customerNumber")
        };
        const cs = await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.customerSummary(), requestBody, {}, true);
        return cs;
    } catch (error) {
        return { error: 'Some error occured. Please try again' };

    }
};

const allCustomerSummaryClient = async () => {
    const { post: postClient } = BaseClient();
    try {
        let requestBody = {};
        const cs = await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.getCustomerSummary(), requestBody, {}, true);
        return cs;
    } catch (error) {
        return { error: 'Some error occured. Please try again' };

    }
};

export {allCustomerSummaryClient};

export default customerSummaryClient;